import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Spin, InputNumber } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { save } from "../../../../../features/save/saveSlice";
import toast from "react-hot-toast";
import Gradient from "../../../../../assets/svg/Gradient.svg";
import SelectCompany from "../SelectCompany";
import BillSummary from "../BillSummary";
import PaymentSummary from "../PaymentSummary";
import PaymentMethod from "../PaymentMethod";
import WaterHeader from "../WaterHeader";
import AccountNumber from "../AccountNumber";
import AmountToPay from "../AmountToPay";
import { fetchData } from "../../../../../features/auth/authSlice";

const WaterModal = ({ isModalOpen, handleCancel }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [step, setStep] = useState(1);
  const [billAmount, setBillAmount] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState();
  const urlWtrCompany = "api/v1/public/fetch-paybills"; 
  const { loading, dataWtrCompany } = useSelector((state) => ({
    loading: state.fetch.loading,
    dataWtrCompany: state.fetch.data[urlWtrCompany] || [],
  }));

  const handleProceed = async () => {
    try {
      await form.validateFields(["pbId", "accountNumber"]);

      const values = form.getFieldsValue(["pbId", "accountNumber"]);

      const selectedCompany = dataWtrCompany?.find(
        (company) => company?.pbId === values?.pbId
      );
      setSelectedCompany(selectedCompany || "");

      const res = await dispatch(
        save({
          url: "api/v1/public/validate-paybill-account",
          pbId: values.pbId,
          accountNumber: values.accountNumber,
        })
      );

      if (res?.payload?.success) {
        await toast.success(res?.payload?.messages?.message);
        await setBillAmount(res?.payload?.data?.result?.amount);
        await form.setFieldsValue({
          editableAmount: res?.payload?.data?.result?.amount,
        });
        await setStep(2);
      } else {
        toast.error(res?.payload?.messages?.message);
      }
    } catch (error) {
      console.log("Validation failed:", error);
    }
  };

  const handleModalCancel = () => {
    setStep(1);
    setBillAmount(null);
    form.resetFields();
    handleCancel();
  };

  const fetchTableData = () => {
    dispatch(
      fetchData({
        url: urlWtrCompany,
        start: 0,
        limit: null,
      })
    );
  };

  useEffect(() => {
    fetchTableData();
  }, []);

  const onFinish = async (data) => {
    const res = await dispatch(
      save({ ...data, url: "api/v1/payments/save-payment-category" })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleModalCancel();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  return (
    <Modal
      open={isModalOpen}
      onCancel={handleModalCancel}
      width="30rem"
      footer={null}
      closeIcon={null}
      className="electricity-modal"
      zIndex={9999}
      styles={{
        body: {
          position: "relative",
        },
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          backgroundImage: `url(${Gradient})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "top right",
          backgroundSize: "100% auto",
          pointerEvents: "none",
          zIndex: 0,
        }}
      />
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        style={{ position: "relative", zIndex: 1 }}
      >
        <Spin spinning={loading}>
          {step === 1 ? (
            <>
              <WaterHeader />
              <SelectCompany form={form} />
              <AccountNumber
                form={form}
                handleCancel={handleModalCancel}
                handleProceed={handleProceed}
              />
            </>
          ) : (
            <>
              <PaymentSummary
                accountNumber={form.getFieldValue("accountNumber")}
                company={selectedCompany}
              />
              <BillSummary billAmount={billAmount}/>
              <AmountToPay amount={billAmount} form={form} />
              <PaymentMethod form={form}   accountNumber={form.getFieldValue("accountNumber")}   company={selectedCompany} handleModalCancel={handleModalCancel}/>
            </>
          )}
        </Spin>
      </Form>
    </Modal>
  );
};

export default WaterModal;
